import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface DevOrAdminRouteProps {
  user?: { role?: string };
}

const DevOrAdminRoute: React.FC<DevOrAdminRouteProps> = ({ user }) => {
  const allowedRoles = ['admin', 'dev'];

  return allowedRoles.includes(user?.role || '') ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace />
  );
};

export default DevOrAdminRoute;
